<div class="modal-container">
    <div class="modal-header">
        <div class="modal-title">
            KPI SELECTION
        </div>
        <div class="modal-close-button" (click)="onCloseButtonClick()">
            <img src="" class="closeIcon" />
        </div>
    </div>
    <div class="modal-body">
        <ng-container *ngIf="!kpisLoading">
            <div class="title">
                Select KPIs for {{selectedPlant.plantName}}
            </div>
            <div class="kpi-options-container" *ngIf="kpiList.length > 0">
                <div class="kpi-options">
                    <div class="kpi-option">
                        <mat-checkbox 
                        (change)="selectAll($event.checked)" 
                        [checked]="allSelected"
                        [indeterminate]="someSelected">
                            <div class="kpi-options-text">
                                Select All
                            </div>
                        </mat-checkbox> 
                    </div>
                    <div class="kpi-option" *ngFor="let kpi of kpiList">
                        <mat-checkbox
                        [(ngModel)]="kpi.selected"
                        (ngModelChange)="onKpiSelected()" >
                            <span appTooltip="{{kpi.name}}" [tooltipPosition]="'top'"
                            [tooltipShow]="(kpi.name.length) > 24">
                                <div class="kpi-options-text">
                                    {{kpi.name | shorten: 24}}
                                </div>
                            </span>
                        </mat-checkbox>
                    </div>
                </div>
            </div>
            <div class="no-kpi-message" *ngIf="kpiList.length === 0">
                <img class="icon" src="assets/error.svg"/>
                <div class="message">No available KPIs to configure</div>
            </div>
            <div class="select-button-container">
                <button (click)="submit()" [ngClass]="{'select-button-disabled': !allSelected && !someSelected, 'select-button-enabled' : allSelected || someSelected}" [disabled]="!allSelected && !someSelected">
                    <div class="select-button-text">
                        SELECT({{count}})
                    </div>
                </button>
            </div>
        </ng-container>
        <ng-container *ngIf="kpisLoading">
            <div class="loading-kpis">
                <app-three-dots-loading class="dots"></app-three-dots-loading>
                <div class="text">Loading KPIs...</div>
            </div>
        </ng-container>
    </div>
</div>